// src/pages/ProfileSimple/index.js
import React, { useMemo } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

export default function ProfileSimple() {
  document.title = "Profile";

  const navigate = useNavigate();

  const user = useMemo(() => {
    const raw = localStorage.getItem("user") || localStorage.getItem("authUser");
    try {
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const logout = () => {
    // front logout (token removed)
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");
    navigate("/login");
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Profile</h4>
            <Button color="danger" onClick={logout}>
              Logout
            </Button>
          </Col>
        </Row>

        <Row className="g-3">
          <Col lg={6}>
            <Card>
              <CardBody>
                <div className="text-muted" style={{ fontSize: 12 }}>
                  Name
                </div>
                <div className="h5 mb-3">{user?.name || "-"}</div>

                <div className="text-muted" style={{ fontSize: 12 }}>
                  Email
                </div>
                <div className="fw-semibold mb-3">{user?.email || "-"}</div>

                <div className="text-muted" style={{ fontSize: 12 }}>
                  Role
                </div>
                <div className="fw-semibold mb-3">{user?.role || "-"}</div>

                <div className="text-muted" style={{ fontSize: 12 }}>
                  Company ID
                </div>
                <div className="fw-semibold">{user?.company_id ?? "-"}</div>
              </CardBody>
            </Card>
          </Col>

         
        </Row>
      </Container>
    </div>
  );
}
